const transactions = {
    en: {
        "transactions.title": "Transactions",
        "transactions.payedId": "Payed ID",
        "transactions.date": "Date",
        "transactions.vin": "VIN",
        "transactions.mark": "Mark",
        "transactions.model": "Model",
        "transactions.year": "Year",
        "transactions.personalNumber": "Personal Number",
        "transactions.amount": "Amount",
        "transactions.paymentType": "Payment Type",
        "transactions.userId": "User ID",
        "transactions.buyer": "Buyer",
        "transactions.paidAmount": "Paid Amount",
        "transactions.addTitle": "Add New User",
        "transactions.editTitle": "Modify user data",
        "transactions.enterUserId": "Enter user ID",
        "transactions.enterVin": "Enter vin code",
        "transactions.enterMark": "Enter mark",
        "transactions.enterModel": "Enter model",
        "transactions.enterYear": "Enter year",
        "transactions.enterBuyer": "Enter buyer",
        "transactions.enterPersonalNumber": "Enter personal number",
        "transactions.enterPaidAmount": "Enter paid amount",
        "transactions.selectType": "Select type",
        "transactions.typeTransportation": "Transportation",
        "transactions.typeCarAmount": "Car Amount",
        "transactions.vinNotFound": "Vin not found",
        "transactions.removeTitle": "Remove Transaction",
        "transactions.removeConfirm": "Do you want to remove transaction?",
    },
    ru: {
        "transactions.title": "Транзакции",
        "transactions.payedId": "ID плательщика",
        "transactions.date": "Дата",
        "transactions.vin": "VIN",
        "transactions.mark": "Марка",
        "transactions.model": "Модель",
        "transactions.year": "Год",
        "transactions.personalNumber": "Личный номер",
        "transactions.amount": "Сумма",
        "transactions.paymentType": "Тип оплаты",
        "transactions.userId": "ID пользователя",
        "transactions.buyer": "Покупатель",
        "transactions.paidAmount": "Оплаченная сумма",
        "transactions.addTitle": "Добавить пользователя",
        "transactions.editTitle": "Изменить данные пользователя",
        "transactions.enterUserId": "Введите ID пользователя",
        "transactions.enterVin": "Введите VIN код",
        "transactions.enterMark": "Введите марку",
        "transactions.enterModel": "Введите модель",
        "transactions.enterYear": "Введите год",
        "transactions.enterBuyer": "Введите покупателя",
        "transactions.enterPersonalNumber": "Введите личный номер",
        "transactions.enterPaidAmount": "Введите оплаченную сумму",
        "transactions.selectType": "Выберите тип",
        "transactions.typeTransportation": "Транспортировка",
        "transactions.typeCarAmount": "Стоимость автомобиля",
        "transactions.vinNotFound": "VIN не найден",
        "transactions.removeTitle": "Удалить транзакцию",
        "transactions.removeConfirm": "Вы хотите удалить транзакцию?",
    },
    geo: {
        "transactions.title": "ტრანზაქციები",
        "transactions.payedId": "გადამხდელის ID",
        "transactions.date": "თარიღი",
        "transactions.vin": "VIN",
        "transactions.mark": "მარკა",
        "transactions.model": "მოდელი",
        "transactions.year": "წელი",
        "transactions.personalNumber": "პირადი ნომერი",
        "transactions.amount": "თანხა",
        "transactions.paymentType": "გადახდის ტიპი",
        "transactions.userId": "მომხმარებლის ID",
        "transactions.buyer": "მყიდველი",
        "transactions.paidAmount": "გადახდილი თანხა",
        "transactions.addTitle": "ახალი მომხმარებლის დამატება",
        "transactions.editTitle": "მომხმარებლის მონაცემების რედაქტირება",
        "transactions.enterUserId": "შეიყვანეთ მომხმარებლის ID",
        "transactions.enterVin": "შეიყვანეთ VIN კოდი",
        "transactions.enterMark": "შეიყვანეთ მარკა",
        "transactions.enterModel": "შეიყვანეთ მოდელი",
        "transactions.enterYear": "შეიყვანეთ წელი",
        "transactions.enterBuyer": "შეიყვანეთ მყიდველი",
        "transactions.enterPersonalNumber": "შეიყვანეთ პირადი ნომერი",
        "transactions.enterPaidAmount": "შეიყვანეთ გადახდილი თანხა",
        "transactions.selectType": "აირჩიეთ ტიპი",
        "transactions.typeTransportation": "ტრანსპორტირება",
        "transactions.typeCarAmount": "ავტომობილის თანხა",
        "transactions.vinNotFound": "VIN ვერ მოიძებნა",
        "transactions.removeTitle": "ტრანზაქციის წაშლა",
        "transactions.removeConfirm": "გსურთ ტრანზაქციის წაშლა?",
    },
};

export default transactions;
